<template>
    <transition name="modal-fade">
        <div class="modal__backdrop" @click="close">
            <div @click.stop class="modal__container" :class="{ 'modal__container--card': isCard === true }">
                <div class="modal__inner" :class="{ 'modal__inner--narrow': narrow === true }">
                    <span v-if="hasCloseButton" @click="close" class="modal__close-btn">&#10006;</span>
                    <header class="modal__header">
                        <slot name="header"></slot>
                    </header>

                    <div class="modal__body">
                        <slot name="body"></slot>
                    </div>

                    <footer class="modal__footer">
                        <slot name="footer"></slot>
                    </footer>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        isCard: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDismissedOnClickBackdrop: {
            type: Boolean,
            required: false,
            default: true,
        },
        hasCloseButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        narrow: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        close: function () {
            if (this.isDismissedOnClickBackdrop === true) {
                this.$emit("close");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.modal {
    &__backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
    }

    &__container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        box-shadow: 2px 2px 20px 1px;
        overflow-x: hidden;
        // max-width: calc(100vw - 30px);
        border-radius: 10px;
        max-height: 70vh;

        &--card {
            border-top: 5px solid #0293d6;
        }
    }

    &__inner {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 1rem;
        border-radius: 0 0 10px 10px;
        height: 100%;
        width: 100%;

        &--narrow {
            width: 75%;
            @media (max-width: 767px) {
                width: 100%;
            }
        }
    }

    &__header,
    &__footer,
    &__body {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    &__close-btn {
        position: absolute;
        top: 0;
        right: 0;
        padding: 16px;
        cursor: pointer;
        user-select: none;
    }
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.3s ease;
}
</style>